<template>
    <v-container>
        <message-component 
            id="message" 
            v-model="isMessage" 
            :success="success"
        >{{ message }}</message-component>
        <v-container class="mt-4">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">
                    タイムスタンプ一括検証
                </v-col>
            </v-row>
        </v-container>
        <v-row class="pl-4">
            <v-col cols="auto">
                <p>
                    最終署名日を指定して、検証する文書を検索してください。
                </p>
                <p>
                    一度に最大100件のファイルを検証することができます。
                </p>
                <p>
                    ※署名方式「電子サイン」で送信されたファイルは対象外となります。
                </p>
            </v-col>
        </v-row>
        <v-row class="pl-4 pb-2">
            <v-col cols="auto">
                <badge-component tile color="unset">
                    <label-component>最終署名日</label-component>
                </badge-component>
            </v-col>
            <v-col cols="3">
                <v-text-field 
                    v-model="date_from" 
                    readonly
                    dense 
                    outlined 
                    clearable
                    v-disabled-icon-focus 
                    background-color="white"
                    placeholder=" 年/月/日" 
                    hide-details
                >
                    <template v-slot:append>
                        <date-picker v-model="date_from"/>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="auto" class="align-self-center text-h5">
                <div>～</div>
            </v-col>
            <v-col cols="3">
                <v-text-field 
                    v-model="date_to" 
                    readonly
                    dense 
                    outlined 
                    clearable
                    v-disabled-icon-focus 
                    background-color="white"
                    placeholder=" 年/月/日" 
                    hide-details
                >
                    <template v-slot:append>
                        <date-picker v-model="date_to"/>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="auto">
                <v-btn 
                    color="blue" 
                    class="white--text"
                    @click="search"
                >
                    検索
                </v-btn>
            </v-col>
        </v-row>
        <v-container>
            <v-row class="mb-2">
                <v-col 
                    class="justify-space-between align-self-end"
                    v-if="resultShow"
                >
                    <p>
                        検索結果: {{ items.length }}件
                    </p>
                </v-col>
                <v-col 
                    class="text-right"
                    v-if="items.length > 0"
                >
                    <v-btn 
                        color="orange" 
                        class="white--text" 
                        @click="submit"
                    >
                        実行
                    </v-btn>
                </v-col>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                disable-pagination
            >
                <template v-slot:item.conclusion_date="{ item }">
                    {{ item.conclusion_date | datetimeFormat }}
                </template>
            </v-data-table>
        </v-container>
        
        <dialog-component
            v-if="dialog" 
            :dialog.sync="dialog" 
            :email="email"
            :contract-object-id-list="contractObjectIdList"
            @success="initialize" 
            @error="error"
        />
        
    </v-container>
</template>

<script>
    import DatePicker from "./DatePickerComponent";
    import DialogComponent from "./DialogComponent";
    import moment from 'moment';
    export default {
        components: {
            DatePicker,
            DialogComponent
        },
        computed: {
            isMessage: {
                get() {
                    return this.message != null;
                },
                set(value) {
                    if (!value) {
                        this.message = null;
                    }
                }
            }
        },
        data() {
            return {
                date_from: null,
                date_to: null,
                dialog: false,
                headers: [
                    {
                        text: '管理ID',
                        align: 'start',
                        width: 20,
                        sortable: false,
                        value: 'agreement_object_id'
                    },
                    { 
                        text: '件名', 
                        sortable: false,
                        width: 20,
                        value: 'contract_name' 
                    },
                    { 
                        text: 'ファイル名', 
                        sortable: false,
                        width: 20,
                        value: 'file_name' 
                    },
                    { 
                        text: '最終署名日', 
                        sortable: false,
                        width: 30,
                        value: 'conclusion_date'
                    }
                ],
                items: [],
                message: null,
                resultShow: false,
                success: false,
            };
        },
        filters: {
            datetimeFormat(date) {
                return moment(date).format('YYYY/MM/DD HH:mm');
            },
        },
        methods: {
            error(message) {
                this.success = false;
                this.message = message;
            },
            search: function () {
                axios.post(
                    '/documents/signature-validation/search',
                    {
                        'date_from': this.date_from,
                        'date_to': this.date_to
                    }
                ).then(res => {
                    if (res.data.success) {
                        this.items = res.data.items;
                        this.resultShow = true;
                    } else {
                        this.items = [];
                        this.resultShow = false;
                        this.success = res.data.success;
                        this.message = res.data.message;
                    }
                }).catch(res => {
                    this.items = [];
                    this.resultShow = false;
                    this.success = false;
                    this.message = "処理に失敗しました";
                }).finally(() => {
                });
            },
            submit() {
                this.contractObjectIdList = this.items.map((data) => data.contract_object_id);
                this.dialog = true;
            },
            initialize(message) {
                this.success = true;
                this.message = message;
            }
        },
        props: ['email'],
    };
</script>

<style scoped>
    .v-btn:not(.v-btn--round).v-size--default {
        height: 50px !important;
    }
    
    p {
        margin-bottom: 0;
    }
    
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
</style>